(function () {
    'use strict';

    angular
        .module('macroPartialService', []);
    angular.module('umbracoAngularFrontEnd', ['ngResource', 'macroPartialService', 'mapApplication.services', 'ngSanitize']);
})();

